export const API_ENDPOINTS = {
  DEV_BASE_URL: 'http://0.0.0.0:8000',
  DEV_LOCAL_URL: 'http://localhost:8000/api',
  PROD_BASE_URL: 'https://youtube-fact-checker.onrender.com/api',
  PROD_LOCAL_URL: '/api',
  HEALTH_CHECK: '/health',
  ANALYZE_VIDEO: '/execute'
}; 